import React from "react";
import "./Service_Content.css";

const Service_Content = ({ titleText, contentText = [], imgSrc }) => {
  return (
    <div className="Service_Content">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-7 order-lg-1 order-2">
            <div className="content_div">
              <p className="title_text">{titleText}</p>

              {contentText?.map((item) => {
                return (
                  <>
                    <p className="content_text">{item}</p>
                  </>
                );
              })}
            </div>
          </div>

          <div className="col-lg-5 col-md-6  order-lg-1 order-1 mb-3">
            <div className="right_img_div">
              <img src={imgSrc} className="right_img" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Service_Content;
